module.exports = __webpack_public_path__ + "static/img/TYLAH-WILLIAMS2.5ac27f0.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/TYLAH-WILLIAMS2.jpg
// module id = yNEp
// module chunks = 0